module.exports = __webpack_public_path__ + "files/zahar.01cdcf899cae3d4bcbacf75b345f4a22.pdf";